import React from "react";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import CommonButton from "../../../components/buttons/CommonButton";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function JornadasDataTable({
  linhas,
  togNovaJornadaModal,
  togEditarJornadaModal,
  apagaJornada,
}) {
  const { baseUrl } = React.useContext(AppContext);
  const tiposHorasSemanais = useTipos("tipos_horas_semanais");

  const colunas = React.useMemo(
    () => [
      {
        Header: "Descrição",
        accessor: "descricao",
        isSorted: true,
      },
      {
        Header: "Horas semanais totais",
        accessor: (row) => {
          return (
            (tiposHorasSemanais &&
              tiposHorasSemanais.find(
                (horasSemanais) =>
                  parseInt(horasSemanais.chave) === parseInt(row.regime)
              )?.valor) ||
            ""
          );
        },
        disableSortBy: true,
      },
      {
        Header: "Intervalo (min)",
        accessor: "intervalo",
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`editar-${row.original.uid}`}
                onClick={() => {
                  togEditarJornadaModal(row.original.uid);
                }}
                color="primary"
                icon="mdi mdi-account-edit"
              >
                Editar
              </DropdownButton>
              <DropdownButton
                key={`excluir-${row.original.uid}`}
                onClick={() => {
                  apagaJornada(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-trash-can"
              >
                Excluir
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [apagaJornada, togEditarJornadaModal]
  );

  return (
    <>
      <div className="row mb-3 mx-0">
        <CommonDataTable
          colunas={colunas}
          linhas={linhas}
          botoes={
            <ButtonRounded
              onClick={() => {
                togNovaJornadaModal();
              }}
              color="primary"
            >
              Cadastrar jornada
            </ButtonRounded>
          }
        />
      </div>
      <div className="row mb-3 mx-0">
        <div className="d-flex justify-content-end gap-1">
          <CommonButton
            onClick={() => {
              window.location.href = `${baseUrl}colaboradores/Colaboradores`;
            }}
            color="danger"
          >
            Voltar
          </CommonButton>
        </div>
      </div>
    </>
  );
}

JornadasDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togNovaJornadaModal: PropTypes.func.isRequired,
  togEditarJornadaModal: PropTypes.func.isRequired,
  apagaJornada: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default JornadasDataTable;
